import React from 'react';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';

import { useCheckoutContext } from '../../state/CheckoutContext';
import { subscriptionType } from '../../utils/checkoutUtils';

import styles from './Terms.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.terms';

export const Terms = () => {
  const { checkoutEntityState } = useCheckoutContext();

  const {
    duration,
    isTrial,
    currency,
    isStudentPromotion,
    isHolidayPromotion,
    products
  } = checkoutEntityState;
  const recurringAmount = products?.[duration]?.recurringAmount;
  const priceWithoutDiscount = products?.[duration]?.priceWithoutDiscount || 0;
  const hideTerms = products?.promotion?.full || isHolidayPromotion;

  if (hideTerms) {
    return null;
  }

  const formattedRecurringPrice = Cldr.formatCurrency(
    recurringAmount,
    currency
  );

  let content;
  if (isStudentPromotion) {
    content = I18n.t(`${I18nPrefix}.students.${subscriptionType(isTrial)}`, {
      studentPrice: formattedRecurringPrice,
      priceWithoutDiscount: Cldr.formatCurrency(priceWithoutDiscount, currency)
    });
  } else {
    content = I18n.t(`${I18nPrefix}.${subscriptionType(isTrial)}.${duration}`, {
      price: formattedRecurringPrice
    });
  }

  return (
    <div className={styles.termsContainer}>
      <p className={styles.terms} data-testid="terms">
        {content}
      </p>
    </div>
  );
};

export default Terms;
